import { get } from "./client";

export async function listActionTypes(): Promise<string[]> {
  return get<string[]>("/actions");
}
